// istanbul ignore file
import React from 'react'
import Modal from '../../../components/Modal'
import { type GroupParaObj } from '../services/configurationService'
import LanguageStrings from '../../../i18n/locales'

const ConfigurationListStrings = LanguageStrings().AssetConfigurationStrings.ConfigurationListString

export const getGroupModel = (groups: GroupParaObj[], handleModalClose: () => void): JSX.Element => {
  const tdrStyle: React.CSSProperties = {
    padding: '10px 0'
  }
  return (
    <Modal sx={{ paddingBottom: '10px' }} height='auto' width='600px' title={`${ConfigurationListStrings.Groups} (${groups.length})`} onClose={handleModalClose}>
      <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
        <table style={{ width: '100%', padding: '10px 5px 0 0' }}>
          <tbody>
            {
              groups.length > 0
                ? groups.map((row, index: number) => (
                    <tr key={index}>
                      <td style={{ margin: '1em 0 0 0', fontSize: '14px', ...tdrStyle, borderBottom: '1px solid #000', textAlign: 'center' }}>{row.group_name}</td>
                      <td style={{ margin: '1em 0 0 0', fontSize: '14px', ...tdrStyle, borderBottom: '1px solid #000', textAlign: 'center' }}>{row.status}</td>
                    </tr>
                ))
                : ''
            }
          </tbody>
        </table>
      </div>
    </Modal>
  )
}
